<template>
  <q-page-container
    class="full-height"
    style="height: 100%"
  >
    <q-page class="">
      <section class="section-service col-12">
        <q-option-group
          hidden
          v-model="panel"
          inline
          :options="[
            { label: 'Tab-1', value: 'tab-1' },
            { label: 'Tab-2', value: 'tab-2' },
          ]"
        />
        <q-tab-panels
          v-model="panel"
          class="panel-services"
        >
          <q-tab-panel
            class="panel-item"
            name="tab-1"
          >
            <q-form ref="formtab1" class="col-12 full-width">
              <div class="title-page-form">Dados da solicitação</div>
              <DefaultSolicitationForm
                :typeOs="typeOs"
                :requestData="requestData"
                :optionsItens="optionsItens"
                :isShownFieldById="isShownFieldById"
              /> 
            </q-form>
          </q-tab-panel>
          <q-tab-panel
            v-if="!isShownFieldById.includes(Number(typeOs))"
            name="tab-2"
            class="col-12 row items-center justify-center"
          >
            <q-form ref="formtab2">
              <div class="title-page">Informações do Serviço</div>
              <component
                :is="form2Mapper[Number(typeOs)]"
                v-if="form2Mapper[Number(typeOs)]"
                :typeOs="Number(typeOs)"
                :addFieldsToSchema="addFieldsToRequestData"
                :itemOsContract="requestData"
              />
              <ServiceInfoForm
                :typeOs="Number(typeOs)"
                :itemOsContract="requestData"
                :cityDetails="cityDetails"
                v-else
              />
              <div class="group-input col-12 row q-mt-sm">
                <RequiredLabel
                  title="Observação"
                  name="observation"
                />
                <q-input
                  class="col-12 q-mt-sm form-tabulacao"
                  outlined
                  type="textarea"
                  dense
                  color="red-9"
                  v-model="requestData.observation"
                  use-input
                  fill-input
                  input-debounce="0"
                  placeholder="Digite até 120 caracteres..."
                  bg-color="white"
                  lazy-rules
                  :rules="[(val) => !!val || 'Campo Obrigatório']"
                />
              </div>
            </q-form>
          </q-tab-panel>
        </q-tab-panels>
        <div>
          <FooterToolbar
            :progressBarValue="progressBar"
            :maxValue="VALUE_MAX_BAR_PROGRESS"
            :nextTabFn="
              isShownFieldById.includes(Number(typeOs))
                ? validateForm
                : addValueBarProgressAndAlterTab
            "
            :isLoading="false"
            :isShowSubmitButton="false"
          />
        </div>
      </section>
    </q-page>
  </q-page-container>
</template>

<script>
  import FooterToolbar from "@/components/SpecialCodes/FooterToolbar.vue";
import BackboneForm from "@/components/SpecialCodes/Forms/BackboneGponForm.vue";
import BuildingWithoutBackboneForm from "@/components/SpecialCodes/Forms/BuildingWithoutBackboneForm.vue";
import DefaultSolicitationForm from "@/components/SpecialCodes/Forms/DefaultSolicitationForm.vue";
import ExternalNetworkProblemForm from "@/components/SpecialCodes/Forms/ExternalNetworkProblemForm.vue";
import MduNapForm from "@/components/SpecialCodes/Forms/MduNapForm.vue";
import MissingNapForm from "@/components/SpecialCodes/Forms/MissingNapForm.vue";
import MissingTapForm from "@/components/SpecialCodes/Forms/MissingTapForm.vue";
import NodeNotReleasedForm from "@/components/SpecialCodes/Forms/NodeNotReleasedForm.vue";
import RequiredLabel from "@/components/SpecialCodes/RequiredLabel.vue";
import ServiceInfoForm from "@/components/SpecialCodes/ServiceInfoForm.vue";
import { AREA_RISCO_BLOQUEIO_ENDERECO, BACKBONE_GPON_PROBLEMA, EQUIPAMENTO_ROUBADO, FALTA_NAP_LOTADA, FALTA_TAP_PASSIVO_LOTADO, INSTALACAO_NAO_CONTEMPLA_PADRAO, NAP_LOTADA_MDU, NODE_NAO_LIBERADO, NODE_OUTAGE, PREDIO_SEM_BACKBONE, RUA_NAO_CABEADA, RUA_NAO_CABEADA_GPON, SERVICO_CONCLUIDO_MDU } from "@/utils/constans/specialCodes";
import moment from "moment";
import { onBeforeMount, provide, reactive, ref } from "vue";

  export default {
    name: "SolicitationForm",
    components: {
      ServiceInfoForm,
      ExternalNetworkProblemForm,
      BackboneForm,
      NodeNotReleasedForm,
      MduNapForm,
      BuildingWithoutBackboneForm,
      MissingTapForm,
      MissingNapForm,
      RequiredLabel,
      FooterToolbar,
      DefaultSolicitationForm,
    },
    props: {
      listWriteOffCode: Array,
      listTypeOS: Array,
      itemOsContract: Object,
      typeOs: String,
      optionsItens: Object,
      city: Object,
    },
    emits: ["saveSchemaRequest", "removeEdit"],

    setup(props, { emit }) {
      moment.locale("pt-br");

      let panel = ref("tab-1");
      let progressBar = ref(0.5);
      const VALUE_MAX_BAR_PROGRESS = 1;

      let requestData = reactive(props.itemOsContract);
      let tabindex = ref(1);

      function addFieldsToRequestData(newFields) {
        Object.assign(requestData, newFields);
      }

      provide("addFieldsToRequestData", addFieldsToRequestData);

      const isShownFieldById = [NODE_OUTAGE, EQUIPAMENTO_ROUBADO, INSTALACAO_NAO_CONTEMPLA_PADRAO, AREA_RISCO_BLOQUEIO_ENDERECO];

      const form2Mapper = {
        [FALTA_TAP_PASSIVO_LOTADO]: MissingTapForm,
        [PREDIO_SEM_BACKBONE]: MduNapForm,
        [NAP_LOTADA_MDU]: MduNapForm,
        [FALTA_NAP_LOTADA]: MissingNapForm,
        [BACKBONE_GPON_PROBLEMA]: BackboneForm,
        [NODE_NAO_LIBERADO]: NodeNotReleasedForm,
        [RUA_NAO_CABEADA]: NodeNotReleasedForm,
        [RUA_NAO_CABEADA_GPON]: NodeNotReleasedForm,
        [SERVICO_CONCLUIDO_MDU]: MduNapForm,
        [INSTALACAO_NAO_CONTEMPLA_PADRAO]: MissingNapForm,
      };

      let schemaRequest = reactive({
        object_id: "",
        osNumber: "",
        typeOS: "",
        statusOS: 1,
        writeOffCode: "",
        observation: "",
        check: false,
        replicate: false,
        source: "",
      });

      const formtab1 = ref(null);
      const formtab2 = ref(null);

      function setTypeOsByServiceOption() {
        if (props.optionsItens.optionsTypeOS.length == 1) {
          requestData.typeOS = props.optionsItens.optionsTypeOS[0];
        }
      }

      async function validateSingleTabForm() {
        const isValid = await formtab1.value.validate();
        if (isValid) {
          await emitData();
        }
        return isValid;
      }

      async function validateForm() {
        let isValid = false;
        let isSingleForm = isShownFieldById.includes(Number(props.typeOs));

        if (isSingleForm) {
          return await validateSingleTabForm();
        }

        if (progressBar.value === VALUE_MAX_BAR_PROGRESS) {
          const isValid = await formtab2.value.validate();
          if (isValid) {
            await emitData();
          }
          return isValid;
        } else {
          isValid = await formtab1.value.validate();
        }
        return isValid;
      }

      function _changeTab() {
        const VALUE_INCREMENT_ID_TAB = 1;
        const STRING_ID_TAB = "tab-";

        tabindex.value += VALUE_INCREMENT_ID_TAB;
        panel.value = STRING_ID_TAB + tabindex.value;

        return true;
      }

      async function addValueBarProgressAndAlterTab() {
        const VALUE_ADD_PROGRESS = 0.5;
        if (
          progressBar.value != VALUE_MAX_BAR_PROGRESS &&
          (await validateForm())
        ) {
          let validateIfChangeTab = _changeTab();

          if (validateIfChangeTab) {
            progressBar.value += VALUE_ADD_PROGRESS;
          }
        } else {
          validateForm();
        }
      }

      async function emitData() {
        emit("saveSchemaRequest", requestData);
      }

      function populateFieldsMduServiceFinished() {
        const fields = {
          movimentTerminal: 0,
          action: "",
          state: 1,
          equipamentNumberInstall: "",
          equipamentNumberUninstall: "",
          cardNumberInstall: "",
          cardNumberUninstall: "",
        };

        addFieldsToRequestData(fields);
      }

      function populateInstallationNotStandard() {
        const fields = {
          impedimento_instalacao: "",
        };

        addFieldsToRequestData(fields);
      }

      function populateFieldsByTypeOs() {
        if (Number(props.typeOs) == SERVICO_CONCLUIDO_MDU) {
          populateFieldsMduServiceFinished();
        }

        if (Number(props.typeOs) == INSTALACAO_NAO_CONTEMPLA_PADRAO) {
          populateInstallationNotStandard();
        }
      }

      function setServiceInformationByTypeOs() {
        addFieldsToRequestData({
          hasServiceInformation: isShownFieldById.includes(Number(props.typeOs))
            ? 0
            : 1,
        });
      }

      function setWriteOffCodeInitialValues() {
        let writeOffCodeDefaultValue =
          props.optionsItens.optionsWriteOffCode[0];

        requestData.writeOffCode = writeOffCodeDefaultValue;
        schemaRequest.writeOffCode = writeOffCodeDefaultValue;
      }

      const cityDetails = {
        atendimento: props.city.atendimento,
        profile: props.city.profile,
      };

      onBeforeMount(() => {
        setTypeOsByServiceOption();
        setServiceInformationByTypeOs();
        populateFieldsByTypeOs();
        setWriteOffCodeInitialValues();
      });

      return {
        panel,
        progressBar,
        schemaRequest,
        requestData,
        formtab1,
        formtab2,
        validateForm,
        addValueBarProgressAndAlterTab,
        validateSingleTabForm,
        isShownFieldById,
        form2Mapper,
        addFieldsToRequestData,
        cityDetails,
      };
    },
  };
</script>

<style scoped lang="scss">
  label {
    font-family: Roboto;
    font-style: normal;
  }

  .q-page-container {
    padding-bottom: 0px !important;
  }

  .label-checkbox-confirm {
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 14px !important;
    letter-spacing: 0.01em !important;
    color: #999999 !important;
  }

  footer {
    background: #e5e5e5 !important;
    height: 12vh;

    .q-toolbar {
      height: 12vh;
    }

    .div-progress {
      height: 8vh;
    }

    .div-btn-next {
      height: 8vh;
    }
  }

  .section-service {
    width: 100%;

    .panel-services {
      background: transparent !important;
      overflow: hidden !important;

      .title-page {
        font-weight: bold;
        font-size: 18px;
        line-height: 19px;
        text-transform: uppercase;
        color: #e2262d;
      }

      .group-input {
        label {
          font-weight: bold;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.4);
        }
      }

      .label-requests-number {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.5);
      }

      .label-requests-description {
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        color: rgba(0, 0, 0, 0.8);
      }
    }
  }
</style>
